import React, { useState } from 'react';
import { useUser } from '../../../User/containers/UserDataStore';
import AccountInfoModal from './AccountInfoModal/AccountInfoModal';
import PersonalInfoModal from './PersonalInfoModal/PersonalInfoModal';
import { useTranslate } from '@above-the-treeline/localization';

function GeneralInfo() {
	const { translate } = useTranslate();
	const userDataStore = useUser();
	const {
		user: { user },
		organization,
	} = userDataStore.state;

	const [
		isPersonalInfoModalVisible,
		setIsPersonalInfoModalVisible,
	] = useState(false);
	const [isAccountInfoModalVisible, setIsAccountInfoModalVisible] = useState(
		false,
	);

	const getLabel = label => <div className="general-info-label">{label}</div>;

	const getValue = value => <div className="general-info-value">{value}</div>;

	const getEditIcon = (title, onClickHandler) => (
		<div
			title={title}
			className="general-info-edit-icon icon-note-icon"
			onClick={onClickHandler}
		/>
	);

	const renderPersonalInfoEditIcon = () =>
		getEditIcon(
			translate('edit_personal_info'),
			onPersonalInfoEditIconClick,
		);

	const renderAccountInfoEditIcon = () =>
		getEditIcon(translate('edit_account_info'), onAccountInfoEditIconClick);

	const doShowAccountInfoEditIcon = () => user.canEditAccountAndPrivileges;

	const onPersonalInfoEditIconClick = () =>
		setIsPersonalInfoModalVisible(true);

	const onAccountInfoEditIconClick = () => setIsAccountInfoModalVisible(true);

	return (
		<div className="general-info">
			<div className="personal-info">
				{getLabel(translate('name'))}
				{getValue(user.fullName)}
				{renderPersonalInfoEditIcon()}
			</div>
			<div className="account-info">
				{getLabel(translate('account'))}
				{getValue(organization.displayName)}
				{doShowAccountInfoEditIcon() && renderAccountInfoEditIcon()}
			</div>
			<PersonalInfoModal
				isVisible={isPersonalInfoModalVisible}
				setIsVisible={setIsPersonalInfoModalVisible}
			/>
			<AccountInfoModal
				isVisible={isAccountInfoModalVisible}
				setIsVisible={setIsAccountInfoModalVisible}
			/>
		</div>
	);
}

export default GeneralInfo;
